import React from 'react';
import PropTypes from 'prop-types';
import Ankeiler from '../sec_ankeiler/component';

import './styles/styles.scss';

/**
 * Bestseller
 *
 * List of bestsellers, by default nested in base_generic-section with layout of layout-one-center and renders ankeiler-small
 */

class Bestsellers extends React.PureComponent {
  constructor(props) {
    super(props);
    this.index = 0;
  }

  get products() {
    return this.props.products || [];
  }

  get store() {
    return this.props.store;
  }

  /**
   * Render bestseller ankeiler
   * @param {Number} index
   */
  componentDOM(index) {
    const { hideRating = false } = this.props;
    if (!this.products.length) {
      return null;
    }
    const badgeValue = this.props.numbered ? index + 1 : null;
    return (
      <Ankeiler
        {...this.products[index]}
        store={this.store}
        position={index + 1}
        badgeValue={badgeValue}
        hideRating={hideRating}
        onePrice
      />
    );
  }

  render() {
    return (
      <div className="bestsellers">
        { this.products.slice(0, 7).map((_, index) => {
          const hiddenSm = index > 4 ? 'hidden-sm' : '';
          return (
            <div key={`item-${index}`} className={`item ${hiddenSm}`}>{this.componentDOM(index)}</div>
          );
        })}
      </div>
    );
  }
}

// proptypes
Bestsellers.propTypes = {
  /**
   * Child components to be rendered inside this wrapper
   */
  products: PropTypes.arrayOf(PropTypes.shape({})),
  store: PropTypes.object,
  numbered: PropTypes.bool,
  hideRating: PropTypes.bool,
};

export default Bestsellers;
